"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, CircleCheck, TrendingUp, Zap, ChartBarBig } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheDigitalWorkshopHero() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section id="the-digital-workshop-hero" ref={sectionRef} className="relative overflow-hidden py-20 lg:py-32 min-h-[90vh] flex items-center transition-colors duration-500 bg-background text-foreground">
      

      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" />
        {}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-primary/5 blur-[120px] rounded-full opacity-50" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className={`lg:col-span-7 flex flex-col gap-8 text-center lg:text-left transition-all duration-1000 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-6">
              <Badge variant="outline" className="inline-flex items-center justify-center border font-medium whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground w-fit border-primary/30 text-primary bg-primary/5 px-4 py-1.5 rounded-full text-sm backdrop-blur-sm ![margin:27px_0px_24px_0px]">
                <Zap className="w-3.5 h-3.5 mr-2 fill-primary" />
                Web Design for Trades & Small Business
              </Badge>

              <div className="block lg:hidden my-12 relative perspective-[1200px] transition-all duration-1000 delay-300">
                <div className={`relative transform-style-3d ${mounted ? "animate-float" : ""}`}>
                  {}
                  <div className="relative rounded-xl bg-[#1a1a1c] border border-white/10 shadow-2xl shadow-primary/10 overflow-hidden transform rotate-y-[-12deg] rotate-x-[5deg] max-w-[280px] mx-auto">
                    {}
                    <div className="h-6 bg-[#252528] border-b border-white/5 flex items-center px-3 gap-1.5">
                      <div className="flex gap-1">
                        <div className="w-1.5 h-1.5 rounded-full bg-red-500/80" />
                        <div className="w-1.5 h-1.5 rounded-full bg-yellow-500/80" />
                        <div className="w-1.5 h-1.5 rounded-full bg-green-500/80" />
                      </div>
                      <div className="ml-2 flex-1 h-3 bg-[#1a1a1c] rounded-full border border-white/5" />
                    </div>

                    {}
                    <div className="relative aspect-[16/10] bg-[#0f0f10]">
                      <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent pointer-events-none" />
                      <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-transparent pointer-events-none z-10 opacity-60" />
                    </div>
                  </div>

                  {}
                  <div className="absolute -right-4 -top-4 transform translate-z-[40px] animate-float-delayed ![margin:0px_30px_0px_0px]">
                    <div className="bg-card/90 backdrop-blur-md border border-white/10 p-2 rounded-xl shadow-lg flex items-center gap-2 ![margin:0px_0px_0px_20px]">
                      <div className="bg-primary/20 p-1.5 rounded-full">
                        <TrendingUp className="w-4 h-4 text-primary" />
                      </div>
                      <div className="text-left">
                        <p className="text-[10px] text-muted-foreground font-medium leading-none">Monthly Leads</p>
                        <p className="text-xs font-bold text-foreground">+40%</p>
                      </div>
                    </div>
                  </div>

                  <div className="absolute -left-2 bottom-2 transform translate-z-[60px] animate-float-reverse">
                    <div className="bg-card/90 backdrop-blur-md border border-white/10 p-2 rounded-xl shadow-lg flex items-center gap-2 ![margin:0px_0px_0px_27px]">
                      <div className="bg-green-500/20 p-1.5 rounded-full">
                        <ChartBarBig className="w-4 h-4 text-green-500" />
                      </div>
                      <div className="text-left">
                        <p className="text-[10px] text-muted-foreground font-medium leading-none">SEO Score</p>
                        <p className="text-xs font-bold text-foreground">98/100</p>
                      </div>
                    </div>
                  </div>

                  <div className="absolute -right-6 bottom-4 transform translate-z-[30px] animate-float z-20">
                    
                  </div>

                  {}
                  <div className="absolute inset-0 -z-10 bg-primary/20 blur-[60px] rounded-full transform translate-z-[-40px] scale-75" />
                </div>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold tracking-tight font-sans leading-[1.1]">
                Professional Websites for{" "}
                <span className="relative inline-block !text-[hsl(44,89%,63%)]">Small Businesses</span>
              </h1>

              <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 font-medium leading-relaxed">
                We build fast, modern websites that help your business attract
                more customers online. Tailored for Australian trades and
                services.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
              <Button asChild size="lg" className="rounded-full text-base px-8 h-14 shadow-[0_0_20px_-5px_var(--color-primary)] hover:shadow-[0_0_30px_-5px_var(--color-primary)] transition-all duration-300">
                <Link to="/PackagesPage">
                  View Packages
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full text-base px-8 h-14 border-foreground/20 hover:bg-foreground/5 hover:text-foreground hover:border-foreground/40 transition-all duration-300">
                <Link to="/ContactPage">
                  Get Started
                </Link>
              </Button>
            </div>

            <div className="pt-8 flex flex-wrap items-center justify-center lg:justify-start gap-x-8 gap-y-4 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <CircleCheck className="w-4 h-4 text-primary" />
                <span>Fast Turnaround</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="w-4 h-4 text-primary" />
                <span>Fixed Price</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="w-4 h-4 text-primary" />
                <span>Local Support</span>
              </div>
            </div>
          </div>

          {}
          <div className={`hidden lg:block lg:col-span-5 relative perspective-[2000px] transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-x-8" : "opacity-0 translate-x-10"}`}>
            {}
            <div className={`relative transform-style-3d transition-transform duration-[3s] ease-in-out ${mounted ? "animate-float" : ""}`}>
              {}
              <div className="relative rounded-xl bg-[#1a1a1c] border border-white/10 shadow-2xl shadow-primary/10 overflow-hidden transform rotate-y-[-12deg] rotate-x-[5deg] hover:rotate-y-[-5deg] hover:rotate-x-[2deg] transition-transform duration-500 group">
                {}
                <div className="h-8 bg-[#252528] border-b border-white/5 flex items-center px-4 gap-2">
                  <div className="flex gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-red-500/80" />
                    <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/80" />
                    <div className="w-2.5 h-2.5 rounded-full bg-green-500/80" />
                  </div>
                  <div className="ml-4 flex-1 max-w-[200px] h-4 bg-[#1a1a1c] rounded-full border border-white/5" />
                </div>

                {}
                <div className="relative aspect-[4/3] bg-[#0f0f10] group-hover:brightness-110 transition-all duration-500">
                  
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent pointer-events-none" />
                </div>
              </div>

              {}
              <div className="absolute -right-4 top-1/4 transform translate-z-[50px] animate-float-delayed hidden sm:block">
                <div className="bg-card/90 backdrop-blur-md border border-white/10 p-3 rounded-2xl shadow-xl flex items-center gap-3">
                  <div className="bg-primary/20 p-2 rounded-full">
                    <TrendingUp className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground font-medium">
                      Monthly Leads
                    </p>
                    <p className="text-sm font-bold text-foreground">+40% Increase</p>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute -left-8 bottom-1/4 transform translate-z-[80px] animate-float-reverse hidden sm:block">
                <div className="bg-card/90 backdrop-blur-md border border-white/10 p-3 rounded-2xl shadow-xl flex items-center gap-3">
                  <div className="bg-green-500/20 p-2 rounded-full">
                    <ChartBarBig className="w-5 h-5 text-green-500" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground font-medium">
                      SEO Score
                    </p>
                    <p className="text-sm font-bold text-foreground">98/100 Optimized</p>
                  </div>
                </div>
              </div>

              <div className="absolute right-12 -bottom-6 transform translate-z-[50px] animate-float-delayed hidden sm:block">
                <div className="bg-card/90 backdrop-blur-md border border-white/10 p-3 rounded-2xl shadow-xl flex items-center gap-3">
                  <div className="bg-primary/20 p-2 rounded-full">
                    <Zap className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground font-medium">
                      Lead Generation
                    </p>
                    <p className="text-sm font-bold text-foreground">3x More Enquiries</p>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute inset-0 -z-10 bg-primary/20 blur-[80px] rounded-full transform translate-z-[-50px]" />
            </div>
          </div>
        </div>
      </div>

      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px) translateZ(50px); }
          50% { transform: translateY(-15px) translateZ(50px); }
        }
        @keyframes float-reverse {
          0%, 100% { transform: translateY(0px) translateZ(80px); }
          50% { transform: translateY(15px) translateZ(80px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 7s ease-in-out infinite 1s;
        }
        .animate-float-reverse {
          animation: float-reverse 8s ease-in-out infinite 0.5s;
        }
        .perspective-2000 {
          perspective: 2000px;
        }
        .transform-style-3d {
          transform-style: preserve-3d;
        }
      `}</style>
    </section>;
}